
import { NgModule } from '@angular/core';
import { AuthorizationComponent } from './authorization.component';
import { AuthorizationService } from './authoriation.service';

@NgModule({
    declarations: [
        AuthorizationComponent
    ],
    imports: [
    ],
    providers: [
        AuthorizationService
    ]
})
export class AuthorizationModule { }